import type { OnInit } from '@angular/core';
import { Component, HostBinding, Input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { getFieldValue } from '@core/jss-utils';
import { NgTemplateOutlet, NgClass } from '@angular/common';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';

@Component({
  selector: 'wl-icon-list',
  templateUrl: './icon-list.component.html',
  styleUrls: [],
  standalone: true,
  imports: [NgTemplateOutlet, NgClass, RichTextWrapperComponent, JssModule],
})
export class IconListComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  @HostBinding('class') hostClasses?: string;

  horizontal = false;

  ngOnInit(): void {
    if (this.rendering && this.rendering.fields) {
      this.horizontal = getFieldValue(this.rendering, 'horizontal', false);

      if (this.horizontal) {
        this.hostClasses = 'd-flex';
      }
    }
  }
}
